import React from 'react';
import { Col, Image, ListGroup as BListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loader from '../shared/components/Loader/Loader';
import ResponsiveHeader from '../shared/components/ResponsiveHeader';
import { withTranslation } from 'react-i18next';

const STATUSES_MAPPER = {
  applying: 'applying',
  'in waitlist': 'brand_consideration',
  'waiting product': 'waiting_product',
  'pending content submission': 'content_approval',
  'waiting content approval': 'content_approval',
  'content work needed': 'content_approval',
  'pending post': 'post_content',
  'pending completion': 'post_content',
  'work needed': 'post_content',
  'pending review': 'content_review',
  'pending stats': 'submit_insights',
  'waiting reward': 'waiting_reward',
  done: 'done',
  canceled: 'canceled',
  declined: 'declined',
}

class ListGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  // move to individual object components
  renderObject(obj) {
    let { objectType, t } = this.props;

    switch (objectType) {
      case 'userOffer':
        return (
          <React.Fragment>
            <Image className="list-group-image rounded" src={obj.offer.pic} />
            <Col className="list-group-offer-info">
              <div className='text-medium-1'>
                {obj.offer.title}
              </div>
              <div className='text-medium-3'>{obj.status_due_date}</div>
              <div className='text-medium-3'>
                {STATUSES_MAPPER[obj.status] ?
                  t(`influencers.offers.statuses.${STATUSES_MAPPER[obj.status]}`)
                  : ''}
              </div>
            </Col>
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            <Image className="list-group-image rounded" src={obj.pic} />
            <Col className='list-group-offer-info'>
              <div className='text-medium-1'>
                {obj.title}
              </div>
            </Col>
          </React.Fragment>
        );
    }
  }

  render() {
    let { objects, title, listGroupKey, loading, error } = this.props;

    return (
      <React.Fragment>
        <ResponsiveHeader xs="h5" md="h4" className="mb-4">
          {title}
        </ResponsiveHeader>

        {(loading || error) && <Loader loading={loading} error={error} />}

        {
          objects.length > 0 ?
            <div className="list-group-container" key={`${listGroupKey}-list-group`} >
              <BListGroup variant="flush">
                {objects.map((obj) => (
                  <BListGroup.Item key={`${listGroupKey}-list-group-${obj.id}`} as={Link}
                    to={`/offer/${obj.offer ? obj.offer.id : obj.id}`}
                    className="row d-flex text-decoration-none"
                  >
                    {this.renderObject(obj)}
                    <Col className="col-auto p-0 align-items-center d-flex">
                      <i className='fal fa-arrow-right' />
                    </Col>
                  </BListGroup.Item>
                ))}
              </BListGroup>
            </div > : null
        }
      </React.Fragment>

    );

  }
}

export default withTranslation()(ListGroup);